export function parseDate(date: string): Date {
  const [year, month, day] = date.split('-');
  return new Date(Number(year), Number(month) - 1, Number(day));
}
export const validDate = (startDate: string, endDate: string) => {
  const start = parseDate(startDate);
  const end = parseDate(endDate);
  return start.getTime() <= end.getTime();
};
export const formatDate = (date: Date) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year}-${month.toString().padStart(2, '0')}-${day
    .toString()
    .padStart(2, '0')}`;
};

export const today = formatDate(new Date());

export const convertDateToString = (date: Date): string => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year}-${month.toString().padStart(2, '0')}-${day
    .toString()
    .padStart(2, '0')}`;
};

export const dateObj = new Date();

export const getSunday = (date?: Date) => {
  const specificDate = date ? date : new Date();
  const sunday = specificDate.getDate() - specificDate.getDay();

  return new Date(specificDate.setDate(sunday));
};

export const prevMonth = (year: number, month: number) => {
  return month === 0 ? new Date(year - 1, 11, 1) : new Date(year, month - 1, 1);
};

export const nextMonth = (year: number, month: number) => {
  return month === 11 ? new Date(year + 1, 0, 1) : new Date(year, month + 1, 1);
};
